import { render } from "./QuizPage.vue?vue&type=template&id=71741322"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"

import "./QuizPage.vue?vue&type=style&index=0&id=71741322&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__